// Shared client-side validation for vessel image uploads. The backend performs
// the authoritative validation (extension + magic-byte sniffing + size); this
// mirror gives users immediate feedback before a request is made.

export const MAX_VESSEL_IMAGE_BYTES = 5 * 1024 * 1024; // 5 MB

export const ALLOWED_VESSEL_IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp'];

export const ALLOWED_VESSEL_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

// accept attribute value shared by file inputs.
export const VESSEL_IMAGE_ACCEPT = 'image/png,image/jpeg,image/webp,.png,.jpg,.jpeg,.webp';

export interface ImageValidationResult {
  ok: boolean;
  error?: string;
}

export function validateVesselImage(file: File): ImageValidationResult {
  const name = file.name.toLowerCase();
  const ext = name.slice(name.lastIndexOf('.'));

  if (!name.includes('.') || !ALLOWED_VESSEL_IMAGE_EXTENSIONS.includes(ext)) {
    return {
      ok: false,
      error: 'Unsupported file type. Allowed: JPG, JPEG, PNG, WEBP.',
    };
  }

  // Browsers populate file.type from the OS; treat an empty type as acceptable
  // since the backend re-checks the real content type via magic bytes.
  if (file.type && !ALLOWED_VESSEL_IMAGE_MIME_TYPES.includes(file.type)) {
    return {
      ok: false,
      error: 'Unsupported image format. Allowed: JPG, PNG, WEBP.',
    };
  }

  if (file.size === 0) {
    return { ok: false, error: 'The selected file is empty.' };
  }

  if (file.size > MAX_VESSEL_IMAGE_BYTES) {
    return { ok: false, error: 'Image is too large. Maximum size is 5 MB.' };
  }

  return { ok: true };
}
